import { ApiResponse, FormStore, GlobalStore } from '@roc/feature-app-core';
import { flow, makeObservable } from 'mobx';
import { DrawService } from '../services/drawService';

const initialForm = {
  fields: {
    entityName: {
      value: '',
      error: null,
      rule: '',
    },
    fullName: {
      value: '',
      error: null,
      rule: '',
    },
    phone: {
      value: '',
      error: null,
      rule: '',
    },
    address: {
      value: '',
      error: null,
      rule: '',
    },
    referenceId: {
      value: '',
      error: null,
      rule: '',
    },
    email: {
      value: '',
      error: null,
      rule: '',
    },
    bankName: {
      value: '',
      error: null,
      rule: '',
    },
    routingNumber: {
      value: '',
      error: null,
      rule: '',
    },
    accountName: {
      value: '',
      error: null,
      rule: '',
    },
    accountNumber: {
      value: '',
      error: null,
      rule: '',
    },
    streetName: {
      value: '',
      error: null,
      rule: '',
    },
    city: {
      value: '',
      error: null,
      rule: '',
    },
    zipCode: {
      value: '',
      error: null,
      rule: '',
    },
    state: {
      value: '',
      error: null,
      rule: '',
    },
    ffcBankName: {
      value: '',
      error: null,
      rule: ''
    },
    ffcRoutingNumber: {
      value: '',
      error: null,
      rule: '',
    },
    ffcAccountName: {
      value: '',
      error: null,
      rule: ''
    },
    ffcAccountNumber: {
      value: '',
      error: null,
      rule: ''
    },
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    showErrors: null,
    error: null,
  },
}

const ENTITY_TYPE = "DrawEntity";

export class WireAuthorizationFormStore extends FormStore {

  private globalStore: GlobalStore;
  private drawService: DrawService;
  initialData: any;

  constructor(globalStore) {
    super(initialForm, globalStore);
    this.drawService = new DrawService();
    this.globalStore = globalStore;

    makeObservable(this, {
      fetchBankInfo: flow,
      approveBankInfo: flow,
      rejectBankInfo: flow
    });
    this.reset();
  }

  reset() {
    super.reset();
    this.initialData = null;
  }

  *fetchBankInfo(entityId: number) {
    try {
      this.reset();
      const response: ApiResponse = yield this.drawService.getBankInfo(entityId, ENTITY_TYPE);
      const data = response?.data?.data;
      this.initialData = data;
      if (!data) {
        this.globalStore.notificationStore.showErrorNotification({
          message: `We couldn't find the bank information for this draw.`,
        });
        return;
      }
      this.loadForm(data);

    } catch (err) {
      console.error(err);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error getting the bank information for this draw.',
      });
    }
  }

  *approveBankInfo(entityId: number) {
    try {

      yield this.drawService.approveBankInfo(entityId);
      this.globalStore.notificationStore.showSuccessNotification({
        message: "Bank information has been approved successfully.",
      });
      return true;
    } catch (err) {
      console.error(err);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error approving the bank information.',
      });
      return false;
    }
  }

  *rejectBankInfo(entityId: number, reason: string) {
    try {
      yield this.drawService.rejectBankInfo(entityId, reason);
      this.globalStore.notificationStore.showSuccessNotification({
        message: "Bank information has been rejected successfully.",
      });
      return true;
    } catch (err) {
      console.error(err);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'There was an error rejecting the bank information.',
      });
      return false;
    }
  }
}